export default {
    one_payment: 'One payment',
    weekly: 'Weekly',
    two_weeks: 'Bi-Weekly',
    bi_monthly: 'Semi-Monthly',
    monthly: 'Monthly',
};
